(function () {
  const modal = document.querySelector('[data-sales-rep-quick-add]');
  if (!modal) return;

  const REPS_URL =
    'https://cdn.shopify.com/s/files/1/0688/3465/6495/files/reps_data_cleaned_038cd211-31d0-4bc1-b0a2-72e61656dfb1.json?v=1786639508';
  const TRIGGER_SELECTOR =
    '.mp-hide-price-call-button-link, .mp-hide-price-call-button, [data-sales-rep-trigger], #contact-rep-trigger';
  const GLOBAL_TRIGGER_SELECTOR = '[data-sales-rep-trigger], #contact-rep-trigger';
  const GRID_SELECTOR = '#ProductGridContainer';

  const dialog = modal.querySelector('.sales-rep-quick-add__dialog');
  const stateSelect = modal.querySelector('[data-sales-rep-state]');
  const statusEl = modal.querySelector('[data-sales-rep-status]');
  const repList = modal.querySelector('[data-sales-rep-list]');
  const productImage = modal.querySelector('[data-sales-rep-product-image]');
  const productTitle = modal.querySelector('[data-sales-rep-product-title]');
  let repsData = [];
  let repsRequest = null;
  let lastFocusedElement = null;
  let activeTrigger = null;

  function getText(element) {
    return element ? element.textContent.replace(/\s+/g, ' ').trim() : '';
  }

  function dismissNativeCallPopup() {
    document.querySelectorAll('.mp-call-popup-show').forEach((popup) => {
      popup.classList.remove('mp-call-popup-show');
    });
  }

  function setStatus(message) {
    statusEl.textContent = message;
  }

  function clearRepList() {
    repList.replaceChildren();
  }

  function setSelectLoading(isLoading) {
    stateSelect.disabled = isLoading;
    if (isLoading) {
      stateSelect.options[0].textContent = 'Loading states...';
    } else {
      stateSelect.options[0].textContent = 'Select Your State';
    }
  }

  function populateStates() {
    const selectedValue = stateSelect.value;
    const firstOption = stateSelect.options[0];
    stateSelect.replaceChildren(firstOption);

    const statesByPostal = new Map();
    repsData.forEach((rep) => {
      if (rep.State && rep.Postal && !statesByPostal.has(rep.Postal)) {
        statesByPostal.set(rep.Postal, rep.State);
      }
    });

    Array.from(statesByPostal.entries())
      .sort((first, second) => first[1].localeCompare(second[1]))
      .forEach(([postal, state]) => {
        const option = document.createElement('option');
        option.value = postal;
        option.textContent = state;
        stateSelect.appendChild(option);
      });

    if (statesByPostal.has(selectedValue)) {
      stateSelect.value = selectedValue;
    }
  }

  function loadReps() {
    if (repsRequest) return repsRequest;

    setSelectLoading(true);
    setStatus('Loading representatives...');

    repsRequest = fetch(REPS_URL)
      .then((response) => {
        if (!response.ok) throw new Error('Representative data failed to load.');
        return response.json();
      })
      .then((data) => {
        repsData = Array.isArray(data) ? data : [];
        populateStates();
        setStatus('Select your state to view your representative.');
      })
      .catch((error) => {
        console.error('Error loading reps data:', error);
        setStatus('Representative lookup is unavailable. Please try again later.');
      })
      .finally(() => {
        setSelectLoading(false);
      });

    return repsRequest;
  }

  function getProductDetails(trigger) {
    if (trigger.dataset && trigger.dataset.productTitle) {
      return {
        title: trigger.dataset.productTitle,
        imageSrc: trigger.dataset.productImage || '',
        imageAlt: trigger.dataset.productTitle,
      };
    }

    // Legacy PDP tiles are not product cards; their ancestors' images are UI icons.
    const isLegacyPdpTrigger = trigger.matches('#contact-rep-trigger, #contact-rep-trigger *');
    const card = isLegacyPdpTrigger ? null : trigger.closest('.grid__item, .card-wrapper, li');
    const titleElement =
      card &&
      (card.querySelector('.card__heading a') ||
        card.querySelector('.card__heading') ||
        card.querySelector('.full-unstyled-link') ||
        card.querySelector('a[href*="/products/"]'));
    const imageElement =
      card &&
      (card.querySelector('.card__media img') ||
        card.querySelector('.media img') ||
        card.querySelector('img'));

    let title = getText(titleElement);
    let resolvedImageElement = imageElement;

    if (!title) {
      const pdpTitleElement = document.querySelector('.product__title h1, h1.product__title');
      const pdpTitle = getText(pdpTitleElement);

      if (pdpTitle) {
        title = pdpTitle;
        resolvedImageElement = document.querySelector('.product__media img');
      }
    }

    title = title || 'Product pricing';
    const imageSrc = resolvedImageElement
      ? resolvedImageElement.currentSrc || resolvedImageElement.src
      : '';
    const imageAlt = resolvedImageElement ? resolvedImageElement.alt || title : title;

    return { title, imageSrc, imageAlt };
  }

  function setProductPreview(details) {
    productTitle.textContent = details.title;

    if (details.imageSrc) {
      productImage.src = details.imageSrc;
      productImage.alt = details.imageAlt;
      productImage.hidden = false;
    } else {
      productImage.removeAttribute('src');
      productImage.alt = '';
      productImage.hidden = true;
    }
  }

  function getInitials(name) {
    return (name || 'CM')
      .split(/\s+/)
      .filter(Boolean)
      .slice(0, 2)
      .map((part) => part.charAt(0))
      .join('')
      .toUpperCase();
  }

  function createFallbackAvatar(name) {
    const fallback = document.createElement('span');
    fallback.className = 'sales-rep-quick-add__rep-fallback';
    fallback.setAttribute('aria-hidden', 'true');
    fallback.textContent = getInitials(name);
    return fallback;
  }

  function createRepCard(rep) {
    const group = document.createElement('div');
    group.className = 'sales-rep-quick-add__rep-group';

    const card = document.createElement('article');
    card.className = 'sales-rep-quick-add__rep';

    const name = rep.Rep || 'Catchmaster Pro Representative';
    const imageUrl = rep['Image URL'];

    if (imageUrl) {
      const image = document.createElement('img');
      image.className = 'sales-rep-quick-add__rep-image';
      image.src = imageUrl;
      image.alt = name;
      image.width = 72;
      image.height = 72;
      image.loading = 'lazy';
      image.addEventListener('error', () => {
        image.replaceWith(createFallbackAvatar(name));
      });
      card.appendChild(image);
    } else {
      card.appendChild(createFallbackAvatar(name));
    }

    const copy = document.createElement('div');
    copy.className = 'sales-rep-quick-add__rep-copy';

    const heading = document.createElement('h4');
    heading.textContent = name;
    copy.appendChild(heading);

    if (rep.Position) {
      const position = document.createElement('p');
      position.textContent = rep.Position;
      copy.appendChild(position);
    }

    const actions = document.createElement('div');
    actions.className = 'sales-rep-quick-add__rep-actions';

    if (rep['Phone number']) {
      const phone = document.createElement('a');
      phone.href = `tel:${String(rep['Phone number']).replace(/[^\d+]/g, '')}`;
      phone.textContent = `Call: ${rep['Phone number']}`;
      actions.appendChild(phone);
    }

    if (rep.email) {
      const email = document.createElement('a');
      email.href = `mailto:${rep.email}`;
      email.textContent = `Email: ${rep.email}`;
      actions.appendChild(email);
    }

    card.appendChild(copy);
    group.appendChild(card);

    if (actions.children.length) {
      group.appendChild(actions);
    }

    return group;
  }

  function showSelectedReps() {
    const selectedState = stateSelect.value;
    clearRepList();

    if (!selectedState) {
      setStatus('Select your state to view your representative.');
      return;
    }

    const reps = repsData.filter((rep) => rep.Postal === selectedState);

    if (!reps.length) {
      setStatus('No representative was found for that state. Please select another state.');
      return;
    }

    setStatus(`${reps.length} representative${reps.length === 1 ? '' : 's'} found.`);
    reps.forEach((rep) => repList.appendChild(createRepCard(rep)));
  }

  function getFocusableElements() {
    return Array.from(
      modal.querySelectorAll(
        'a[href], button:not([disabled]), select:not([disabled]), textarea:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])'
      )
    ).filter((element) => {
      const rect = element.getBoundingClientRect();
      return rect.width > 0 && rect.height > 0;
    });
  }

  function openModal(trigger) {
    dismissNativeCallPopup();
    activeTrigger = trigger;
    lastFocusedElement = document.activeElement;
    setProductPreview(getProductDetails(trigger));
    clearRepList();
    stateSelect.value = '';
    setStatus(repsData.length ? 'Select your state to view your representative.' : 'Loading representatives...');

    modal.hidden = false;
    document.body.classList.add('sales-rep-quick-add-lock');
    activeTrigger.setAttribute('aria-expanded', 'true');
    dialog.focus({ preventScroll: true });
    loadReps();
  }

  function closeModal() {
    if (modal.hidden) return;

    dismissNativeCallPopup();
    modal.hidden = true;
    document.body.classList.remove('sales-rep-quick-add-lock');

    if (activeTrigger) activeTrigger.setAttribute('aria-expanded', 'false');
    if (lastFocusedElement && typeof lastFocusedElement.focus === 'function') {
      lastFocusedElement.focus({ preventScroll: true });
    }

    activeTrigger = null;
    lastFocusedElement = null;
  }

  function enhanceTriggers(root) {
    root.querySelectorAll(TRIGGER_SELECTOR).forEach((trigger) => {
      const link = trigger.classList.contains('mp-hide-price-call-button-link')
        ? trigger
        : trigger.closest('.mp-hide-price-call-button-link');
      const enhancedTarget = link || trigger;

      enhancedTarget.setAttribute('aria-haspopup', 'dialog');
      enhancedTarget.setAttribute('aria-controls', 'SalesRepQuickAdd');
      enhancedTarget.setAttribute('aria-expanded', 'false');

      if (trigger.tagName === 'BUTTON') {
        trigger.type = 'button';
        trigger.setAttribute('aria-label', 'Call for price. Find your representative.');
      }
    });
  }

  function handleCallTriggerClick(event) {
    const trigger = event.target.closest(TRIGGER_SELECTOR);

    if (trigger && (trigger.matches(GLOBAL_TRIGGER_SELECTOR) || trigger.closest(GRID_SELECTOR))) {
      event.preventDefault();
      event.stopImmediatePropagation();
      openModal(trigger);
    }
  }

  document.addEventListener('click', handleCallTriggerClick, true);

  document.addEventListener('click', (event) => {
    if (event.target.closest('[data-sales-rep-close]')) {
      event.preventDefault();
      closeModal();
    }
  });

  document.addEventListener('keydown', (event) => {
    if (modal.hidden) return;

    if (event.key === 'Escape') {
      event.preventDefault();
      closeModal();
      return;
    }

    if (event.key !== 'Tab') return;

    const focusableElements = getFocusableElements();
    const firstElement = focusableElements[0];
    const lastElement = focusableElements[focusableElements.length - 1];

    if (!firstElement || !lastElement) {
      event.preventDefault();
      return;
    }

    if (event.shiftKey && document.activeElement === firstElement) {
      event.preventDefault();
      lastElement.focus();
    } else if (!event.shiftKey && document.activeElement === lastElement) {
      event.preventDefault();
      firstElement.focus();
    }
  });

  stateSelect.addEventListener('change', showSelectedReps);

  enhanceTriggers(document);
  loadReps();

  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType === Node.ELEMENT_NODE) enhanceTriggers(node);
      });
    });
  });

  observer.observe(document.body, { childList: true, subtree: true });
})();
